import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { clearSupportSession } from "@/modules/shared/api/axios";

// Where a support session lands when it is over. The page was loaded fresh, so
// nothing about the customer is left in memory. It shows no customer screen and
// no login form: the operator's work continues in the Portal.
export default function SupportEndedPage() {
  const [params] = useSearchParams();
  const expired = params.get("reason") === "expired";
  const [canClose, setCanClose] = useState(true);

  const closeTab = () => {
    window.close();
    // A tab the Portal opened closes at once. If this one is still here a
    // moment later, the browser refused, so say so instead of offering a
    // button that does nothing.
    setTimeout(() => setCanClose(false), 400);
  };

  useEffect(() => {
    clearSupportSession();
    // After the operator's own "Exit support", go straight back to the Portal
    // tab. An expired session stays on screen so the reason can be read.
    if (!expired) closeTab();
  }, [expired]);

  return (
    <main className="min-h-screen grid place-items-center bg-slate-50 p-6 text-slate-800">
      <section className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-6 text-center shadow-sm">
        <h1 className="text-lg font-semibold">{expired ? "Support session expired" : "Support session ended"}</h1>
        <p className="mt-2 text-sm text-slate-600">
          {expired
            ? "The 15 minutes are over, or the session was replaced from the Portal. Reconnect from the Portal to continue."
            : "Read-only access to the customer account has been closed."}
        </p>
        {canClose ? (
          <button type="button" onClick={closeTab} className="mt-4 rounded-md bg-slate-800 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-700">
            Close this tab
          </button>
        ) : (
          <p className="mt-4 text-sm text-slate-600">You can close this tab now.</p>
        )}
      </section>
    </main>
  );
}
